import * as types from '../constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: false,
  updatedOn: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PROVIDER_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.PROVIDER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        updatedOn: action.updatedOn,
      };
    case types.PROVIDER_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };

    case types.RESET:
      return initialState;

    case types.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
